import { settings } from "app";
import { Datagrid, FunctionField, NumberField, ReferenceField, SelectField, TextField } from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { NationalityType } from "utils/choices";
import RowActions from "./RowActions";

// Practices and internships differ only in the nomenclature they point at.
const ScheduledItemsGrid = ({ collection, source, reference, label }) => (
  <Datagrid
    bulkActionButtons={false}
    rowClick={false}
    sx={[settings.style.detailsDatagrid, { "& .RaDatagrid-headerCell": { textAlign: "left" } }]}
  >
    <ReferenceField
      source={source}
      reference={reference}
      label={label}
      link={false}
      sortable={false}
      emptyText="-"
    >
      <TextField
        source="name"
        emptyText="-"
      />
    </ReferenceField>
    <SelectField
      source="nationality"
      choices={NationalityType}
      label="Националност"
      sortable={false}
      emptyText="-"
    />
    <ReferenceField
      source="instructionLanguageId"
      reference={administrationRequests.getInstructionLanguagesSelect()}
      label="Език"
      link={false}
      sortable={false}
      emptyText="-"
    >
      <TextField
        source="name"
        emptyText="-"
      />
    </ReferenceField>
    <NumberField
      source="semester"
      label="Семестър"
      sortable={false}
      textAlign="left"
      emptyText="-"
    />
    <NumberField
      source="auditoriumOccupancy"
      label="Аудиторна заетост (ч.)"
      sortable={false}
      textAlign="left"
      emptyText="-"
    />
    <NumberField
      source="practicalExercisesPerSemester"
      label="Часове / семестър"
      sortable={false}
      textAlign="left"
      emptyText="-"
    />
    <NumberField
      source="durationInCalendarDays"
      label="Календарни дни"
      sortable={false}
      textAlign="left"
      emptyText="-"
    />
    <NumberField
      source="credits"
      label="Кредити"
      sortable={false}
      textAlign="left"
      emptyText="-"
    />
    <FunctionField
      label=""
      sortable={false}
      render={() => <RowActions collection={collection} />}
    />
  </Datagrid>
);

export default ScheduledItemsGrid;
